export default __webpack_public_path__ + "static/media/certifi_02.046aeb5b.png";